// P8: single source of truth for whether an async Favorite MUTATION (add /
// remove) may still touch frontend state after its await.
// A late response from an account that has since logged out / switched must
// NOT mutate (or roll back into) the current account's state.
//
// Pure so it is unit-testable without rendering the provider.
export function isAuthUnchanged(currentEpoch, currentUserId, actingUserId, actingEpoch) {
  return (
    currentEpoch === actingEpoch &&
    currentUserId === actingUserId &&
    !!currentUserId
  );
}
